import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const ColourChipsList = styled("ul")`
    list-style-type: none;
    padding: 0;
    overflow: hidden;
    margin: 0;
`
export const ThumbsContainer = styled("div")`
    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }
    overflow-x: auto;
    margin-bottom: 0.25rem;
    display: flex;

    @media (min-width: ${breakpoints.values.md}px) {
        max-width: 25rem;
    }

    @media (min-width: ${breakpoints.values.lg - 130}px) {
        max-width: 30rem;
    }

    .swiper-container {
        width: 100%;
    }

    .swiper-wrapper {
        display: flex;
        flex-direction: row;
    }
    .swiper-slide {
        border-style: solid;
        border-color: transparent;
        border-width: 0 0 0.1875rem;
        transition: 200ms border-color;
        height: auto;
    }

    .swiper-slide-thumb-active {
        border-color: ${({theme}) => theme.colours.text.default};
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        display: none;
    }

    & + div.product-summary-favourites-container {
        bottom: 2rem;
    }
`

export const ThumbImage = styled("img")`
    height: 0.5rem;
    width: 100%;
    object-fit: cover;
    display: block;
`
